import phone from 'phone';

const fallbackMessage = (intl, descriptor, defaultMessage) => {
  if (intl) {
    return intl.formatMessage(descriptor);
  }

  return defaultMessage;
};

export function validatePhoneNumber(rawPhoneNumber, countryCode, intl) {
  const phoneNumber = typeof rawPhoneNumber === 'string' ? rawPhoneNumber.trim() : '';

  if (!phoneNumber) {
    return {
      isValid: false,
      error: fallbackMessage(intl, { id: 'phone.required' }, 'Phone number is required'),
      truncatedPhoneNumber: null,
      fullPhoneNumber: null
    };
  }

  if (!countryCode) {
    return {
      isValid: false,
      error: fallbackMessage(intl, { id: 'country.code.required' }, 'Country code is required'),
      truncatedPhoneNumber: null,
      fullPhoneNumber: null
    };
  }

  if (countryCode.startsWith('+')) {
    countryCode = countryCode.slice(1);
  }

  const phoneWithoutLeadingZero = phoneNumber.startsWith('0') ? phoneNumber.slice(1) : phoneNumber;
  const intlPhone = `+${countryCode}${phoneWithoutLeadingZero}`;
  const result = phone(intlPhone, {
    strictDetection: true
  });

  if (!result.isValid) {
    return {
      isValid: false,
      error: fallbackMessage(intl, { id: 'phone.invalid' }, 'Invalid phone number'),
      truncatedPhoneNumber: null,
      fullPhoneNumber: null
    };
  }

  return {
    isValid: true,
    error: null,
    truncatedPhoneNumber: phoneWithoutLeadingZero,
    fullPhoneNumber: intlPhone
  };
}